import { ref } from 'vue';
import { IFrontendServiceContainer } from '@phi/frontend/service-container';

const TIGHT_EDGE_FAIRING = 1.5;
const LOOSE_EDGE_FAIRING = 0.001;

export type IEdgeTightness = ReturnType<typeof edge_tightness_provider>;

export const edge_tightness_provider = ({
    logging_jcore: {
        set_global_fairing_strength,
        get_global_fairing_strength,
    },
    logging: {
        LOG,
        display_message_to_user,
    },
}: IFrontendServiceContainer) => {
    const edges_are_tight = ref(false);

    function set_tight_edges() {
        set_global_fairing_strength(TIGHT_EDGE_FAIRING);
        edges_are_tight.value = true;
        //const s = get_global_fairing_strength();
        //display_message_to_user(LOG.INFO, `Edges are now tight (strength is now ${s})`);
    }

    function set_loose_edges() {
        set_global_fairing_strength(LOOSE_EDGE_FAIRING);
        edges_are_tight.value = false;
        //const s = get_global_fairing_strength();
        //display_message_to_user(LOG.INFO, `Edges are now loose (strength is now ${s})`);
    }

    function toggle_edge_tightness(x?: boolean | undefined) {
        if (x === undefined ? edges_are_tight.value : !x)
            set_loose_edges();
        else
            set_tight_edges();
    }

    return {
        set_tight_edges,
        set_loose_edges,
        toggle_edge_tightness,
        edges_are_tight,
    };
};
